var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-wrap",on:{"click":function($event){return _vm.$router.push({ path: '/home' })}}},[_c('img',{staticClass:"logo-img",attrs:{"src":require("@/assets/logo.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }